import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-450bb79a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "News", -1))
const _hoisted_2 = { class: "third" }
const _hoisted_3 = { class: "two-thirds" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_panel = _resolveComponent("panel")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_panel, {
      class: "head",
      bg: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("h1", null, _toDisplayString(_ctx.NewsTitle), 1),
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_panel, {
      class: "columns py-20",
      id: "pageContent"
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", _hoisted_2, [
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: '/news'
          }, {
            default: _withCtx(() => [
              _createTextVNode("News")
            ]),
            _: 1
          }),
          _createTextVNode(" / " + _toDisplayString(_ctx.NewsTitle), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ]),
      _: 3
    })
  ]))
}